import styled from "styled-components";

export const Container = styled.section`
  margin: 120px 0 0 0;
  padding: 30px calc(2vw);
  position: relative;
  z-index: 1;
  h2 {
    margin: 0px auto 20px;
    text-align: center;
  }
  .partners-subtitle {
    text-align: center;
  }
  .partners-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin: 48px 0;
    .partners-card {
      display: flex;
      text-align: center;
      justify-content: center;
      /* background-color: var(--prices-background); */
      /* width: 130px; */
      /* height: 180px; */
      padding: 20px;
      border-radius: 5px;
      position: relative;
      a {
        max-width: 100%;
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        outline: none !important;
        &:focus {
          border: none;
        }
        img {
          max-width: 100%;
          padding: 0.5rem !important;
          filter: invert(100) saturate(0);
        }
      }
      p {
        background: linear-gradient(to right, #000 50%, #fff 50%);
        -webkit-text-fill-color: transparent;
        /* -webkit-background-clip: text; */
        background-size: 200%, 100%;
        background-position: 100%;
        transition: 1s;
        font-size: 24px;
        font-weight: bold;
        padding-bottom: 10px;
      }
      p:hover {
        background-position: 0%;
      }
    }
  }
  @media screen and (min-width: 1200px) {
    padding: 30px 21px;
  }
`;
